import { Link } from 'react-router-dom';
import type { DineInMenuThemeTokens } from '../hooks/useDineInMenuTheme';
import type { HallPaymentStatus } from '../services/hallApi';
import { HALL_CASE_TABLE_ID, HALL_CASE_TIP_PATH } from '../data/hallCaseMock';

export function HallPaymentSuccess({
  payment,
  tokens,
}: {
  payment: HallPaymentStatus;
  tokens: DineInMenuThemeTokens;
}) {
  const isTip = payment.kind === 'tip';
  const isCaseMock = payment.tableId === HALL_CASE_TABLE_ID;
  const menuTo = isCaseMock
    ? '/menu?case=table20'
    : payment.tableId
      ? `/menu?table=${encodeURIComponent(payment.tableId)}`
      : '/menu';
  const tipTo = isCaseMock
    ? HALL_CASE_TIP_PATH
    : payment.iikoOrderId
      ? `/tip/${encodeURIComponent(payment.iikoOrderId)}`
      : null;
  const items = payment.items ?? [];

  return (
    <div className="max-w-md mx-auto w-full px-4 pt-10 pb-16" style={{ color: tokens.text, fontFamily: 'Manrope, sans-serif' }}>
      <p className="text-[11px] tracking-[0.2em] uppercase mb-2" style={{ color: tokens.muted }}>
        Стол {payment.tableNumber ?? '—'}
        {payment.sectionName ? ` · ${payment.sectionName}` : ''}
      </p>
      <h1
        className="text-[2rem] leading-none font-bold uppercase mb-2"
        style={{ fontFamily: 'Unbounded, sans-serif', letterSpacing: '-0.04em' }}
      >
        {isTip ? 'Чаевые оплачены' : 'Оплата прошла'}
      </h1>
      <p className="text-sm mb-8" style={{ color: tokens.mutedSoft }}>
        {isTip ? 'Спасибо.' : ''}
      </p>

      {payment.waiterName ? (
        <p className="text-sm mb-4" style={{ color: tokens.mutedSoft }}>
          Официант: {payment.waiterName}
        </p>
      ) : null}

      {items.length > 0 ? (
        <ul className="space-y-1.5 mb-3">
          {items.map((item, i) => (
            <li key={`${item.name}-${i}`} className="flex justify-between gap-3 text-sm">
              <span>
                {item.name}
                {item.amount > 1 ? ` ×${item.amount}` : ''}
              </span>
              <span>{Math.round(item.sum)} ₽</span>
            </li>
          ))}
        </ul>
      ) : null}

      <div className="flex justify-between text-sm font-semibold mb-8">
        <span>{isTip ? 'Чаевые' : 'Итого'}</span>
        <span>{Math.round(payment.amount)} ₽</span>
      </div>

      {!isTip && tipTo ? (
        <Link
          to={tipTo}
          className="block w-full py-3 text-center text-sm font-semibold uppercase tracking-wide mb-3"
          style={{ background: tokens.text, color: tokens.bg }}
        >
          Оставить чаевые
        </Link>
      ) : null}

      <Link to={menuTo} className="block text-center text-sm underline" style={{ color: tokens.muted }}>
        Вернуться в меню
      </Link>
    </div>
  );
}
